import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getEntityTemplates } from '../../services/dtServices'
import { EntityType } from '../../components/DTStudio/interfaces'
import { resetOrgScopedData } from './orgSlice'

interface NavType {
    isOpen: boolean
    navList: EntityType[]
    isLoadingTemplates: boolean
}

const initialState: NavType = {
    isOpen: false,
    navList: [], //entity list
    isLoadingTemplates: false,
}

export const getEntities = createAsyncThunk(
    'nav/getEntities',
    async (orgId: string, thunkAPI) => {
        thunkAPI.dispatch(updateLoadingTemplates(true))
        try {
            const response = await getEntityTemplates(orgId)
            return response
        } catch (error) {
            return thunkAPI.rejectWithValue(error)
        } finally {
            thunkAPI.dispatch(updateLoadingTemplates(false))
        }
    },
)

const navSlice = createSlice({
    name: 'nav',
    initialState,
    reducers: {
        updateNavToggle(state, action) {
            state.isOpen = action.payload
        },
        updateLoadingTemplates(state, action) {
            state.isLoadingTemplates = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(resetOrgScopedData, (state) => {
            state.navList = []
        })
        builder.addCase(
            getEntities.fulfilled,
            (state, action: PayloadAction<EntityType[]>) => {
                state.navList = action.payload
            },
        )
    },
})

export const { updateNavToggle, updateLoadingTemplates } = navSlice.actions
export default navSlice.reducer
